import React from 'react';
import styled from 'styled-components';
import { Colors } from '@prezi/dragon';

type Props = {
    size: number;
    children: any;
};

const Caption = styled.div<{ size: number }>`
    color: ${Colors.neutral200};
    font-size: ${p => p.size}px;
    line-height: ${p => p.size}px;
`;

export default ({ size, children }: Props) => {
    if (!children) {
        return null;
    }
    return <Caption size={size}>{children}</Caption>;
};
